import { useDispatch, useSelector } from "react-redux";
import Action from "../redux/Action";

const PromoForInput = () => {
  const dispatch = useDispatch();
  const formValue = useSelector((state) => state.reducer.formValue);

  const handlePromoChange = async (name, value) => {
    Action.handleFormChange(dispatch, { name, value, formValue });
  };

  const options = [
    { value: "EVERYONE", label: "Everyone" },
    { value: "NEW_ACCOUNT", label: "New Account" },
    { value: "SPECIFIC_USER", label: "Specific User" },
    { value: "GIFT", label: "Gift" },
  ];

  return (
    <div className="flex flex-row items-center gap-5">
      {options.map((option) => (
        <div key={option.value} className="flex items-center">
          <input
            checked={formValue.promoTarget === option.value}
            onChange={(e) => handlePromoChange(e.target.name, e.target.value)}
            id={option.value}
            type="radio"
            value={option.value}
            name="promoTarget"
            className="w-4 h-4 text-gold-secondary bg-gray-100 border-gray-300 focus:ring-gray-primary"
          />
          <label
            htmlFor={option.value}
            className="ml-2 text-sm font-medium text-gray-900 dark:text-gray-300"
          >
            {option.label}
          </label>
        </div>
      ))}
    </div>
  );
};

export default PromoForInput;
